import moment from "moment";
import {ButtonFilterConfigDTO, FilterDashboardDTO, FilterDateKeyDTO} from "../dto/dashboard.dto";
import {ApexAxisChartSeries, ApexXAxis} from "ng-apexcharts";
import {DataMenuOverall, DataReportCategory, DataVenueOverall} from "../repository/entity/dashboard.entity";

export const GreetingDashboardText: string = "Measure your restaurant’s rating and track your menus";

export const FilterDateKey: FilterDateKeyDTO = {
  day: "aDay",
  week: "aWeek",
  month: "aMonth",
  year: "aYear"
}

export const ButtonFilterConfig: ButtonFilterConfigDTO[] = [
  {filter: FilterDateKey.year, label: '12 Months'},
  {filter: FilterDateKey.month, label: '30 Days'},
  {filter: FilterDateKey.week, label: '7 Days'},
  {filter: FilterDateKey.day, label: '24 Hours'}
];

export const ChartSeries: ApexAxisChartSeries = [{name: "Load data chart", data: [0]}];

export const ChartXAxis: ApexXAxis = {
  floating: false,
  categories: []
};

export const FilterDate: FilterDashboardDTO = {
  currentDate: moment().format("YYYY-MM-DD"),
  prevDate: moment().format("YYYY-MM-DD"),
  reportCategory: "venue",
  branch: "",
  menuIds: "",
}

export const VenueOverall: DataVenueOverall = {
  label: "Venue",
  rating: 0,
  trend: "increase",
  trendValue: 0
}

export const MenuOverall: DataMenuOverall = {
  label: "Venue",
  rating: 0,
  trend: "increase",
  trendValue: 0
}

export const ReportCategories: DataReportCategory[] = [
  {
    label: "Venue",
    value: "venue"
  },
  {
    label: "Menu",
    value: "menu"
  }
]
